<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MSA"][obj_mission.I > 0? "EMSA": "AMSA"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">

                                    <CRow>
                                        <CCol col="10"></CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["MSA"]["ACT"]}} ?</label>
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="obj_mission.RS" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["MSA"]["MS"]}}</h6>
                                        </CCol>
                                    </CRow>

                                    <CRow style="margin-left: 3px">
                                        <CCol col="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["IAGI"]}} :</label>
                                            <customtreeselect :multiple="true"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              valueConsistsOf="LEAF_PRIORITY"
                                                              :disable-branch-nodes="false"
                                                              :clearable="true"
                                                              :placeholder="getLanguage['GL']['ALL']"
                                                              @input="AgentGroupChange"
                                                              :limit="1"
                                                              :limitText="count => `+${count}`"
                                                              :disabled="obj_mission.I > 0 && !obj_mission.enableEdit"
                                                              v-model="obj_mission.AGIT" />
                                        </CCol>
                                        <CCol col="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["MN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['MSA']['MN']" size="sm" :value="obj_mission.MN" @change="v => obj_mission.MN = v" ref="MN" :disabled="obj_mission.I > 0 && !obj_mission.enableEdit"></CInput>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MN','MSA','MN') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">
                                                {{this.getLanguage["MSA"]["MC"]}}
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name" style="top: -310% !important; left: -340px !important; ">{{getLanguage["HELP"]["MSACODE"]}}</span>
                                                </div><span class="required" /> :
                                            </label>
                                            <span class="WCMsg" v-if="obj_mission.MDC != null">{{ this.obj_mission.MDC.length }} / 5 </span>
                                            <span class="WCMsg" v-else> 0 / 5 </span>
                                            <CInput maxlength="5" size="sm" :value="obj_mission.MDC" @change="v => obj_mission.MDC = v" :placeholder="getLanguage['MSA']['MC']" :disabled="obj_mission.I > 0 && !obj_mission.enableEdit" ref="MDC" />
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MDC','MSA','MC') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["C"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency"
                                                        :placeholder="getLanguage['MSA']['C']"
                                                        :max-height="200"
                                                        v-model="obj_mission.CI"
                                                        :disabled="obj_mission.I > 0"
                                                        @input="CurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('CI', 'MSA', 'C') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["MSA"]["MR"]}}</h6>
                                        </CCol>
                                    </CRow>

                                    <CRow style="margin-left: 3px">
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["MT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_MissionTypeOption"
                                                        :placeholder="getLanguage['MSA']['MT']"
                                                        :max-height="200"
                                                        v-model="obj_mission.MT"
                                                        :disabled="obj_mission.I > 0"
                                                        ref="MT" />
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MT', 'MSA', 'MT') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["MP"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_MissionPayoutOption"
                                                        :placeholder="getLanguage['MSA']['MP']"
                                                        :max-height="200"
                                                        v-model="obj_mission.MDT"
                                                        :disabled="obj_mission.I > 0 && !obj_mission.enableEdit"
                                                        @input="MissionStartDateChange(obj_mission.MD.startDate, obj_mission.MDT, obj_mission.MDV)"
                                                        ref="MDT" />
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MDT', 'MSA', 'MP') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["PM"]["DW"]}} : </span>
                                            </label>
                                            <CInput :placeholder="getLanguage['PM']['DW']" :disabled="obj_mission.I > 0 && !obj_mission.enableEdit" size="sm" v-model="obj_mission.MDV" ref="MDV" @change="MissionStartDateChange(obj_mission.MD.startDate, obj_mission.MDT, obj_mission.MDV)"></CInput>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MDV', 'PM', 'DW') }}</span>
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["MSA"]}} {{this.getLanguage["GL"]["SD"]}}<span class="required" /> :</label>
                                            <span v-if="obj_mission.I > 0 && !obj_mission.enableEdit">
                                                <CInput type="text" disabled size="sm" vertical :placeholder="this.getLanguage['GL']['SD']" :value="obj_mission.MD.startDate | moment('DD MMM YYYY HH:mm:ss')"></CInput>
                                            </span>
                                            <span v-else>
                                                <date-range-picker :autoApply="true"
                                                                   opens="right"
                                                                   :show-dropdowns="true"
                                                                   v-model="obj_mission.MD"
                                                                   @update="MissionDateRangePickerUpdateEvent"
                                                                   :ranges="false"
                                                                   :single-date-picker="true"
                                                                   class="pcDaterange"
                                                                   :minDate="minDate"
                                                                   :disabled="true">
                                                    <div slot="input" slot-scope="picker">
                                                        <div v-if="obj_mission.MD.startDate != ''">
                                                            <input type="text" class="form-control form-control-sm"
                                                                   readonly
                                                                   :value="obj_mission.MD.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                   @change="DateTimeChange('MD',$event)" />
                                                        </div>
                                                        <div v-else>
                                                            <input type="text" class="form-control form-control-sm"
                                                                   readonly
                                                                   @change="DateTimeChange('MD',$event)" />
                                                        </div>
                                                    </div>
                                                </date-range-picker>
                                            </span>
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["MSA"]}} {{this.getLanguage["GL"]["ED"]}}<span class="required" /> :</label>
                                            <CInput size="sm" disabled vertical :placeholder="this.getLanguage['GL']['ED']" :value="missionEndDate | moment('DD MMM YYYY HH:mm:ss')" />
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 3px">
                                        <CCol col="12">
                                            <strong>{{this.getLanguage['MSA']['AR']}}</strong>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 3px">
                                        <CCol class="col-1" style="padding-right: 0px">
                                            <CRow>
                                                <CCol style="max-width: 60px; padding-right: 0px">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage['DLSS']['OF']}}
                                                    </label>
                                                </CCol>
                                                <CCol style="padding-top: 3px; padding-left: 0px; padding-right: 0px">
                                                    <label class="switch" :style="[!obj_mission.enableEdit?{'pointer-events':'none'}:{}]">
                                                        <input type="checkbox" :checked="bool_OnOff" @change="v => bool_OnOff = v.target.checked ">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol class="col-11">
                                            <CRow>
                                                <CCol class="col-2" style="padding-right: 0px">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage['DLSS']['LR']}}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["MSALRQA"]}}</span>
                                                        </div>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-1" style="padding-top: 3px;">
                                                    <label class="switch" :style="[!obj_mission.enableEdit?{'pointer-events':'none'}:{}]">
                                                        <input type="checkbox" :checked="bool_LROOOnOff" @change="v => bool_LROOOnOff = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['CLD']}}</label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <CInput size="sm" class="inline w-100" v-model="obj_mission.CLD" :disabled="!obj_mission.enableEdit"></CInput>
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('CLD','DLSS','CLD') }}</span>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol class="col-2" style="padding-right: 0px">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage['DLSS']['DR']}}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["DRQA"]}}</span>
                                                        </div>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-1" style="padding-top: 3px;">
                                                    <label class="switch" :style="[!obj_mission.enableEdit?{'pointer-events':'none'}:{}]">
                                                        <input type="checkbox" :checked="bool_DROOOnOff" @change="v => bool_DROOOnOff = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MDA']}} <span class="amountNote" v-if="getThousandCurrency"><br />{{getLanguage["GL"]["CUR"]}}</span></label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <CInput size="sm" class="inline w-100" :disabled="!obj_mission.enableEdit" :prepend="currencySymbol"
                                                            :value="ThousandSeparator(obj_mission.MDA, getThousandCurrency ? 3 : 2)"
                                                            @change="v => obj_mission.MDA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('MDA','DLSS','MDA') }}</span>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MOA']}}</label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <CInput size="sm" class="inline w-100" v-model="obj_mission.MCOD" :disabled="!obj_mission.enableEdit"></CInput>
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('MCOD','DLSS','MOA') }}</span>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol class="col-2" style="padding-right: 0px">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage['DLSS']['TR']}}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["MSATRQA"]}}</span>
                                                        </div>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-1" style="padding-top: 3px;">
                                                    <label class="switch" :style="[!obj_mission.enableEdit?{'pointer-events':'none'}:{}]">
                                                        <input type="checkbox" :checked="bool_TROOOnOff" @change="v => bool_TROOOnOff = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MTA']}} <span class="amountNote" v-if="getThousandCurrency"><br />{{getLanguage["GL"]["CUR"]}}</span></label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <CInput size="sm" class="inline w-100" :disabled="!obj_mission.enableEdit" :prepend="currencySymbol"
                                                            :value="ThousandSeparator(obj_mission.MTA, getThousandCurrency ? 3 : 2)"
                                                            @change="v => obj_mission.MTA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('MTA','DLSS','MTA') }}</span>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MGP']}}</label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <CInput size="sm" class="inline w-100" v-model="obj_mission.MBC" :disabled="!obj_mission.enableEdit"></CInput>
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('MBC','DLSS','MGP') }}</span>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol class="col-2" style="padding-right: 0px">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage['MSA']['CDR']}}
                                                    </label>
                                                </CCol>
                                                <CCol class="col-1" style="padding-top: 3px;">
                                                    <label class="switch" :style="[!obj_mission.enableEdit?{'pointer-events':'none'}:{}]">
                                                        <input type="checkbox" :checked="bool_CDOnOff" @change="v => bool_CDOnOff = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </CCol>
                                                <CCol class="col-2">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['MSA']['CD']}}</label>
                                                </CCol>
                                                <CCol class="col-4">
                                                    <treeselect :multiple="true"
                                                                :options="dd_ContactDetailOption"
                                                                :placeholder="getLanguage['MSA']['CD']"
                                                                :max-height="200"
                                                                v-model="obj_mission.CD"
                                                                :disabled="!obj_mission.enableEdit"
                                                                :limit="1"
                                                                :limitText="count => `+${count}`"
                                                                ref="CD" />
                                                    <span class="ErrMsg">{{ ValidationMissionErrMsg('CD','MSA','CD') }}</span>
                                                </CCol>
                                            </CRow>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('AOIQR','MSA','AOIQR') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>3</span>{{this.getLanguage["MSA"]["MPS"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 3px">
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["PT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_PrizeTypeOption"
                                                        :placeholder="getLanguage['MSA']['PT']"
                                                        :max-height="200"
                                                        v-model="obj_mission.PT"
                                                        :disabled="obj_mission.I > 0"
                                                        @input="PrizeAmountChange()"
                                                        ref="PT" />
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('PT', 'MSA', 'PT') }}</span>
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["MSA"]["TBA"]}} <span class="required" /> : </span>
                                            </label>
                                            <CInput size="sm" class="inline inline40 w-100" :prepend="currencySymbol"
                                                    :value="ThousandSeparator(obj_mission.TBA, getThousandCurrency ? 3 : 2)"
                                                    :disabled="obj_mission.I > 0"
                                                    @change="v=>PrizeAmountChange(1,v)" ref="TBA"></CInput>
                                            <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('TBA', 'MSA', 'TBA') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["MSA"]["TP"]}}<span class="required" /> : </span>
                                            </label>
                                            <CInput size="sm" class="inline inline40 w-100"
                                                    :value="ThousandSeparator(obj_mission.TP, 0)"
                                                    :disabled="obj_mission.I > 0"
                                                    @change="v=>PrizeAmountChange(2,v)" ref="TP"></CInput>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('TP', 'MSA', 'TP') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["MSA"]["MIN"]}}<span v-if="obj_mission.PT==2" class="required" /> : </span>
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name" style="top: -120% !important; left: -340px !important; ">{{getLanguage["HELP"]["MSAMP"]}}</span>
                                                </div>
                                            </label>
                                            <CInput size="sm" class="inline inline40 w-100" :prepend="currencySymbol"
                                                    :value="ThousandSeparator(obj_mission.MINP, getThousandCurrency ? 3 : 2)"
                                                    :disabled="obj_mission.I > 0"
                                                    @change="v => PrizeAmountChange(3,v)" ref="MINP"></CInput>
                                            <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MINP', 'MSA', 'MIN') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["MSA"]["MAX"]}}<span v-if="obj_mission.PT==2" class="required" /> : </span>
                                                <div class="custom_tooltip">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="tooltiptext2 campaign-name" style="top: -120% !important; left: -340px !important; ">{{getLanguage["HELP"]["MSAMAXP"]}}</span>
                                                </div>
                                            </label>
                                            <CInput size="sm" class="inline inline40 w-100" :prepend="currencySymbol"
                                                    :value="ThousandSeparator(obj_mission.MAXP, getThousandCurrency ? 3 : 2)"
                                                    :disabled="obj_mission.I > 0 || obj_mission.PT == 1"
                                                    @change="v => obj_mission.MAXP = parseFloat(RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2))" ref="MAXP" />
                                            <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                            <span class="ErrMsg">{{ ValidationMissionErrMsg('MAXP', 'MSA', 'MAX') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow style="margin-left: 3px">
                                        <CCol col="12">
                                            <strong>{{this.getLanguage['MSA']['PL']}}:</strong>
                                            <CButton size="sm" color="outline-info" style="float: right" @click="addPrize()" v-if="obj_mission.I == 0"><span class='plusIcon cil-plus'></span>{{this.getLanguage["MSA"]["AP"]}}</CButton>
                                            <CRow style="padding-left: 15px; padding-right: 15px; display: block;">
                                                <div class="pageBtn" v-if="obj_mission.I > 0">
                                                    <button @click="ctrPage_1(+int_Page_1 - 1,obj_mission.I)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_1"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPage_1(+int_Page_1,obj_mission.I,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_1}}</span>
                                                    <button @click="ctrPage_1(+int_Page_1 + 1,obj_mission.I)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                                <table class="custom-table afb-blue" style="padding-top: 5px">
                                                    <thead>
                                                        <tr>
                                                            <th width="50px">{{this.getLanguage['GL']['NO']}}</th>
                                                            <th width="50px" v-if="obj_mission.enableEdit">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th width="100px">{{this.getLanguage['PM']['CB']}}<i @click="setSortTable_1('IC',obj_mission.I)" :class="setSortLogo_1('IC')" class="sortlogo"></i></th>
                                                            <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable_1('AGN',obj_mission.I)" :class="setSortLogo_1('AGN')" class="sortlogo"></i></th>
                                                            <th>{{this.getLanguage['MSA']['UID']}}<i @click="setSortTable_1('U',obj_mission.I)" :class="setSortLogo_1('U')" class="sortlogo"></i></th>
                                                            <th v-if="obj_mission.I > 0">{{this.getLanguage['MSA']['A']}}<i @click="setSortTable_1('A',obj_mission.I)" :class="setSortLogo_1('A')" class="sortlogo"></i></th>
                                                            <th>{{this.getLanguage['MSA']['RMK']}}<i @click="setSortTable_1('RMK',obj_mission.I)" :class="setSortLogo_1('RMK')" class="sortlogo"></i></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_mission.MPrize == 0 || !obj_mission.MPrize">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_mission.MPrize" :class="data.MRS == 1? 'blacklist-row': data.MRS == 3? 'freeze-row': ''">
                                                        <td>{{index+1}}</td>
                                                        <td v-if="obj_mission.enableEdit">
                                                            <span id="actionBtnCol" v-if="!data.IC">
                                                                <div class="custom_tooltip" v-if="obj_mission.I == 0">
                                                                    <i class="cil-trash" @click='removePrize(index)'></i>
                                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                </div>
                                                                <div class="custom_tooltip" v-if="obj_mission.enableEdit">
                                                                    <i class="cil-color-border" @click='editPrize(data,index)'></i>
                                                                    <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                </div>
                                                            </span>
                                                        </td>
                                                        <td id="actionBtnCol">
                                                            <span style="color: red" v-if="data.IC">{{ getLanguage["GL"]["YES"] }}</span><span v-else style="color: green">{{ getLanguage["CNO"]["NO"] }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.AGI > 0">{{ data.AGN }}</span>
                                                        </td>
                                                        <td>
                                                            <span v-if="data.IRP" style="color: gray">{{ data.U }}</span><span v-else>{{ data.U }}</span>
                                                        </td>
                                                        <td class="tableCtnRight" v-if="obj_mission.I > 0">{{currencySymbol}} {{ThousandSeparator(data.A, getThousandCurrency ? 3 : 2)}}</td>
                                                        <td>{{ data.RMK }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                            <!--<span class="ErrMsg" ref="MPrize">{{ //ValidationMissionErrMsg('MPrize','MSA', 'PL') }}</span>-->
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <span class="RAMsg" style="float: unset; font-size: 14px;">{{this.getLanguage["MSA"]["TRA"]}} : {{currencySymbol}} {{ this.formatNumber(this.totalAmount, this.getThousandCurrency ? 3 : 2, '') }}</span><br />
                                    <CButton color="outline-info" size="sm" @click="saveMission()" style="margin-top:15px">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isAPL">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MSA"][ddDefaultMemberList && ddDefaultMemberList.length > 0 ? "ECM" : "AP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddPrize()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["GL"]["AGT"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :flat="true"
                                                    :options="ddAgentList"
                                                    :defaultExpandLevel="Infinity"
                                                    @input="selectAgentOptions"
                                                    :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                    v-model="searchAgent" />
                                        <span class="ErrMsg">{{ ValidationPrizeErrMsg('AGI') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{this.getLanguage['MEM']['U']}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :async="true"
                                                    :cacheOptions="bool_cacheOptionValue"
                                                    :load-options="loadMemberOptions"
                                                    :defaultOptions="ddDefaultMemberList"
                                                    :options="ddMemberList"
                                                    :disable-branch-nodes="true"
                                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                    :placeholder="this.utilGetDDLanguage('MEM.U')"
                                                    v-model="obj_prizelist.MEMI" />
                                        <span class="ErrMsg">{{ ValidationPrizeErrMsg('MEMI') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <!--<CCol col="6" v-if="obj_mission.PT!=1">
                                    <label class="col-form-label-sm"> {{//getLanguage["MSA"]["A"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                    <CInput vertical size="sm" :prepend="currencySymbol" :value="ThousandSeparator(obj_prizelist.A, getThousandCurrency ? 3 : 2)" @change="v => obj_prizelist.A = parseFloat(RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2))" :disabled="obj_mission.PT==1" />
                                    <span class="ErrMsg">{{ //ValidationPrizeErrMsg('A') }}</span>
                                </CCol>-->
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MSA"]["RMK"]}} :</label>
                                        <CInput vertical size="sm" :placeholder="getLanguage['MSA']['RMK']" :value="obj_prizelist.RMK" @change="v => obj_prizelist.RMK = v" />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="savePrize()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["RS"]}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["CI"] }}
                                                <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["TNMT"]["ORGN"] }}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MSA"]["MT"] }}
                                            </template>
                                            <template v-else-if="header == 'PT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MSA"]["PT"] }}
                                            </template>
                                            <template v-else-if="header == 'MN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MSA"]["MN"] }}
                                                <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MSD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MSA"]["MDR"] }}
                                                <i @click="setSortTable('MSD')" :class="setSortLogo('MSD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                                <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                            </template>
                                            <template v-else-if="header == 'UB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["MSA"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addMission()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["MSA"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_MissionTypeOption"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('MSA.MT')"
                                            v-model="arr_FV['MT']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MSA"]["MN"]}} :</span>
                                <CInput size="sm" :value="arr_FV['MN']" @change="v => arr_FV['MN'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["MSA"]["PT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_PrizeTypeOption"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('MSA.PT')"
                                            v-model="arr_FV['PT']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency2"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["MSA"]["MSAL"] }}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["TNMT"]["ORGN"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MT"] }}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["PT"] }}
                                    </template>
                                    <template v-else-if="header == 'MN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MN"] }}
                                        <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MSD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MDR"] }}
                                        <i @click="setSortTable('MSD')" :class="setSortLogo('MSD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["TNMT"]["ORGN"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MT"] }}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["PT"] }}
                                    </template>
                                    <template v-else-if="header == 'MN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MN"] }}
                                        <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MSD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MSA"]["MDR"] }}
                                        <i @click="setSortTable('MSD')" :class="setSortLogo('MSD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage["GL"]["UB"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Mission.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Mission">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-trash" @click='removeMission(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block; margin-left: 0px;">
                                            <i class="cil-color-border" @click='editMission(data.I)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block; margin-left: 0px;">
                                            <i class="cil-color-border"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="fa fa-clone" @click='editMission(data.I, true)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="fa fa-clone"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                        </div>                                        
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                    <CCol col="4">
                                        <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line">
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateStatus(data)">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                        <span v-else-if="(isSENS == 1 && data.AGI != curAGI)" class="grid-line">
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.RS">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                        <span :style="renderMissionStyle(data.MCS)">{{ renderMissionCurrentStatus(data.MCS) }}</span>
                                    </CCol>
                                </template>
                                <template v-else-if="header == 'CI'">
                                    {{ data.ISOC }}
                                </template>
                                <template v-else-if="header == 'GN'">
                                    {{ renderAgentGroupName(data.GN, data.GPC) }}
                                </template>
                                <template v-else-if="header == 'MT'">
                                    {{ renderMissionType(data.MT) }}
                                </template>
                                <template v-else-if="header == 'PT'">
                                    {{ renderPrizeType(data.PT) }}
                                </template>
                                <template v-else-if="header == 'MN'">
                                    <router-link :to="{ path:'/R/MSAR', query:{ tn: data.MN, df: data.MSD, dt: parseDateToJsonString(setEndDate(data.MED)) }}">
                                        {{ data.MN }}
                                    </router-link>
                                </template>
                                <template v-else-if="header == 'MSD'">
                                    <span class="grid-line">{{ getLanguage["PM"]["F"] }}: {{ formatDate(data.MSD, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line">{{ getLanguage["PM"]["T"] }}: {{ formatDate(data.MED, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>
                                <template v-else-if="header == 'UB'">
                                    {{ data.UB }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constMissionType, constMissionDurationType, constPrizeType, constContactDetail } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, numeric, requiredIf, alphaNum, decimal, minValue, minLength } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen, constHouseBrand } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import draggable from 'vuedraggable';

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC_1: 100, //Row Count
                int_Total_1: 0,
                int_Page_1: 1,
                int_IC_1: 1, // Item Count
                int_TP_1: 1, //Total Page
                str_tableSortBy_1: "CTS", //(sort the table col name)
                bool_isSort_1: false, // Table Ascending Descending
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_isAPL: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                newImg: false,
                arr_FV: {
                    "MN": "",
                    "MT": null,
                    "PT": null,
                    "AGI": null,
                    "RS": 2,
                    "CI": null,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    },
                },
                arr_Mission: [],
                obj_mission: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "MN": "",
                    "IAGI": "",
                    "MT": null,
                    "MDT": null,
                    "MDV": "",
                    "MD": { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    "MSD": null,
                    "MED": null,
                    "CI": null,
                    "MPrize": [],
                    "MDC": null,
                    "MPT": 1,
                    "MDA": null,
                    "MCOD": null,
                    "MTA": null,
                    "MBC": null,
                    "CLD": null,
                    "TBA": null,
                    "MINP": null,
                    "MAXP": null,
                    "TP": null,
                    "PT": null,
                    "CDL": "",
                    "CD": null,
                    "AOIQR": null
                },
                obj_prizelist: {
                    I: 0,
                    AGI: null,
                    AGIT: null,
                    MEMI: null,
                    //A: null,
                    RMK: null,
                    IsEdit: false
                },
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_MissionTypeOption: [],
                dd_PrizeTypeOption: [],
                dd_ContactDetailOption: [],
                dd_MissionPayoutOption: [],
                bool_MissionCV: false,
                bool_PrizeListCV: false,
                dd_currency: [],
                dd_currency2: [],
                constAccessType: constAccessType,
                minDate: this.getTodayDate(),
                missionEndDate: this.getTodayDate(),
                bool_OnOff: false,
                bool_DROOOnOff: false,
                bool_TROOOnOff: false,
                bool_LROOOnOff: false,
                bool_CDOnOff: false,
                searchAgent: null,
                ddAgentList: null,
                currencySymbol: '',
                bool_cacheOptionValue: true,
                ddMemberList: [],
                searchAgi: 0,
                dd_agentgroup_temp: [],
                ddDefaultMemberList: [],
                totalAmount: 0,
                obj_Post: {
                    SelectedBrands: []
                },
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'CI', 'GN', 'MT', 'PT', 'MN', 'MSD', 'CTS', 'UB'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                bool_isCopyPrize: false
            }
        },
        validations: {
            obj_prizelist: {
                AGI: {
                    required: requiredIf(function () {
                        return this.obj_mission.I == 0;
                    })
                },
                MEMI: {
                    required: requiredIf(function () {
                        return this.obj_mission.I == 0;
                    })
                },
                //A: {
                //    required: requiredIf(function () {
                //        return this.obj_mission.PT != 1;
                //    }), numeric
                //},
            },
            obj_mission: {
                "AOIQR": {
                    required: requiredIf(function () {
                        return this.bool_OnOff && !this.bool_LROOOnOff && !this.bool_DROOOnOff && !this.bool_TROOOnOff && !this.bool_CDOnOff;
                    })
                },
                "CI": { required },
                "MN": { required },
                "MT": { required },
                "MDT": {
                    required: requiredIf(function (vm) {
                        return vm.enableEdit;
                    })
                },
                "MDV": { required, numeric, minValueValue: minValue(1) },
                //"MPrize": {
                //    required: requiredIf(function (vm) {
                //        return vm.I > 0;
                //    })
                //},
                "MDC": { required, minLengthValue: minLength(2) },
                "MDA": {
                    decimal, minValueValue: minValue(0), required: requiredIf(function () {
                        return this.bool_DROOOnOff;
                    }) },
                "MCOD": {
                    numeric, minValueValue: minValue(0), required: requiredIf(function () {
                        return this.bool_DROOOnOff;
                    })},
                "MTA": {
                    decimal, minValueValue: minValue(0), required: requiredIf(function () {
                        return this.bool_TROOOnOff;
                    }) },
                "MBC": {
                    numeric, minValueValue: minValue(0), required: requiredIf(function () {
                        return this.bool_TROOOnOff;
                    }) },
                "CLD": {
                    numeric, minValueValue: minValue(1), required: requiredIf(function () {
                        return this.bool_LROOOnOff;
                    }) },
                "TBA": { required, decimal, minValueValue: minValue(0) },
                "MINP": {
                    decimal, minValueValue: minValue(0.001), required: requiredIf(function (vm) {
                        return vm.PT == 2;
                    }) },
                "MAXP": {
                    decimal, minValueValue: minValue(0.001), required: requiredIf(function (vm) {
                        return vm.PT == 2;
                    })
                },
                "CD": {
                    required: requiredIf(function () {
                        return this.bool_CDOnOff;
                    })
                },
                "TP": { required, numeric, minValueValue: minValue(1) },
                "PT": { required }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess','checkModuleIndex']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_MissionCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMissionList();
            },
            obj_prizelist() {
                if (this.obj_prizelist.MEMI) {
                    this.bool_cacheOptionValue = true;
                }
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/PrizeDrop`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.add))) {
                                    that.removeDefaultColumn('RS')
                                    that.removeColumn('RS')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/PrizeDrop/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.CTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.CTS.endDate = "";
                    }
                }
                if (type == "ASD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_mission.MD.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.obj_mission.MD.startDate = "";
                    }
                }
                if (type == "AED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_mission.MD.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.obj_mission.MD.endDate = "";
                    }
                }
            },
            //DisplayMissionEndDate(missionEndDate, isToString = false) {

            //    if (isToString) {
            //        return moment(missionEndDate).subtract('seconds', 1).format("YYYY-MM-DD HH:mm:ss");
            //    }

            //    return moment(missionEndDate).subtract('seconds', 1);
            //},
            MissionStartDateChange(missionStartDate, PayoutMethod, PayoutUntil) {
                this.missionEndDate = missionStartDate;
                if (PayoutMethod != null && PayoutUntil != null && PayoutUntil > 0) {
                    if (PayoutMethod == 1) { //daily
                        this.missionEndDate = moment(missionStartDate).add(PayoutUntil, 'd');
                    }
                    if (PayoutMethod == 2) { // weekly
                        this.missionEndDate = moment(missionStartDate).add(PayoutUntil, 'w');
                    }
                    if (PayoutMethod == 3) { //monthly
                        this.missionEndDate = moment(missionStartDate).add(PayoutUntil, 'M');
                    }
                    this.missionEndDate = moment(this.missionEndDate).subtract('seconds', 1).format("YYYY-MM-DD HH:mm:ss");
                }                
                //return moment(this.missionEndDate, 'DD MMM YYYY HH:mm:ss').toString();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MSA', 'P', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_MissionCV = false;
                this.bool_isCopyPrize = false;
            },
            closeAddPrize() {
                this.bool_isAPL = !this.bool_isAPL;
                this.bool_PrizeListCV = false;
                this.bool_cacheOptionValue = false;
                this.ddMemberList = [];
            },
            addPrize() {
                this.obj_prizelist = {
                    I: 0,
                    AGI: null,
                    AGIT: null,
                    MEMI: null,
                    //A: null,
                    RMK: null,
                    IsEdit: false
                };
                //if (this.obj_mission.PT == 1) {
                //    this.obj_prizelist.A = 0;
                //}
                this.searchAgent = null;
                this.ddDefaultMemberList = null;
                this.bool_isAPL = true;
            },
            savePrize() {
                this.bool_PrizeListCV = true;
                this.$v.obj_prizelist.$touch();
                if (!this.$v.obj_prizelist.$error) {
                    if (!this.obj_mission.MPrize) {
                        this.obj_mission.MPrize = [];
                    }
                    if (this.obj_prizelist.AGIT) {
                        for (var i = 0; i < this.dd_agentgroup_temp.length; i++) {
                            if (this.dd_agentgroup_temp[i].id == this.obj_prizelist.AGIT) {
                                this.obj_prizelist.AGN = this.dd_agentgroup_temp[i].label;
                                break;
                            }
                        }
                    }
                    if (this.obj_prizelist.MEMI) {
                        for (var i = 0; i < this.ddMemberList.length; i++) {
                            if (this.ddMemberList[i].id == this.obj_prizelist.MEMI) {
                                this.obj_prizelist.U = this.ddMemberList[i].label;
                                break;
                            }
                        }
                    }
                    var exist = false;
                    var member_exist = false;
                    var index = -1;
                    for (var i = 0; i < this.obj_mission.MPrize.length; i++) {
                        if (this.obj_mission.MPrize[i].I == this.obj_prizelist.I) {
                            exist = true;
                            index = i;
                        }
                        if (this.obj_mission.MPrize[i].I != this.obj_prizelist.I && this.obj_mission.MPrize[i].MEMI > 0 && this.obj_mission.MPrize[i].MEMI == this.obj_prizelist.MEMI) {
                            member_exist = true;
                        }
                    }
                    if (member_exist) {
                        this.showErrorMessage(null, this.getLanguage['MSA']['MEMEX'], 1000);
                    } else {
                        this.obj_prizelist.IsEdit = true;
                        if (exist && index > -1) {
                            //this.totalAmount = this.totalAmount + parseFloat(this.RemoveThousandSeparator(this.obj_prizelist.A, this.getThousandCurrency ? 3 : 2)) - this.obj_mission.MPrize[index].A;
                            this.obj_mission.MPrize[index] = this.obj_prizelist;                            
                        } else {
                            this.obj_prizelist.I = (this.obj_mission.MPrize && this.obj_mission.MPrize.length > 0) ? (this.obj_mission.MPrize.length + 1) : 1;
                            this.obj_mission.MPrize.push(this.obj_prizelist);
                            //this.totalAmount += parseFloat(this.RemoveThousandSeparator(this.obj_prizelist.A, this.getThousandCurrency ? 3 : 2));
                        }
                        this.bool_isAPL = false;
                        this.bool_PrizeListCV = false;
                        this.obj_prizelist = {};
                    }
                }
            },
            removePrize(index) {
                //this.currentPrizeRank = this.obj_mission.MPrize[index].R;
                this.$delete(this.obj_mission.MPrize, index);
                this.$forceUpdate();
            },
            editPrize(data, index) {
                this.bool_PrizeListCV = false;
                this.obj_prizelist = Object.assign({}, data);
                if (this.obj_prizelist.AGI > 0) {
                    this.searchAgent = '3-' + this.obj_prizelist.AGI;
                } else {
                    this.obj_prizelist.AGI = null;
                    this.searchAgent = null;
                }
                if (this.obj_prizelist.MEMI > 0) {
                    this.ddDefaultMemberList = [
                        { id: this.obj_prizelist.MEMI, label: this.obj_prizelist.U }
                    ];
                } else {
                    this.obj_prizelist.MEMI = null;
                    this.ddDefaultMemberList = null;
                }
                this.bool_isAPL = true;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMissionList();
            },
            ctrPage_1(newPage, missionId, inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_1 = Math.max(1, Math.min(newPage, this.int_TP_1));
                }
                else {
                    this.int_Page_1 = (newPage > this.int_TP_1) ? 1 : (newPage < 1) ? this.int_TP_1 : newPage;
                }
                this.int_IC_1 = this.int_Page_1;
                this.getMissionPrizeList(missionId);
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMissionList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            //CalculatePrizeAmount(CS) {
            //    var totalAmount = 0;
            //    if (this.obj_mission.MPrize != null) {
            //        for (var i = 0; i < this.obj_mission.MPrize.length; i++) {
            //            var amount = 0;
            //            amount = parseFloat(this.obj_mission.MPrize[i].A);
            //            totalAmount += amount;
            //        }
            //        return this.formatNumber(totalAmount, '.', ',', this.getThousandCurrency ? 3 : 2, CS);
            //    }
            //    else {
            //        return this.formatNumber(totalAmount, '.', ',', this.getThousandCurrency ? 3 : 2, CS);
            //    }
            //},
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMissionList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            setSortTable_1(SV, missionId) {
                if (missionId > 0) {
                    this.int_Page_1 = 1;
                    this.int_IC_1 = 1;
                    this.str_tableSortBy_1 = SV;
                    this.bool_isSort_1 = !this.bool_isSort_1;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                    this.getMissionPrizeList(missionId);
                }
            },
            setSortLogo_1(str_TF) {
                return `cil-${this.str_tableSortBy_1 == str_TF ? (this.bool_isSort_1 ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;
                this.dd_MissionPayoutOption = [{
                    id: 1,
                    label: this.getLanguage['PM']['DLY']
                }, {
                    id: 2,
                    label: this.getLanguage['PM']['WLY']
                }, {
                    id: 3,
                    label: this.getLanguage['PM']['MLY']
                    }];

                this.dd_MissionTypeOption = [{
                    id: 1,
                    label: this.getLanguage['PM']['AGP']
                }];

                this.dd_PrizeTypeOption = [
                    {
                        id: 1,
                        label: this.getLanguage['PM']['FA']
                    },
                    {
                        id: 2,
                        label: this.getLanguage['PM']['RDA']
                    }
                ];

                this.dd_ContactDetailOption = [
                    {
                        id: 1,
                        label: this.getLanguage['MEM']['E']
                    },
                    {
                        id: 2,
                        label: this.getLanguage['MEM']['PN']
                    },
                    {
                        id: 3,
                        label: this.getLanguage['MEM']['WC']
                    },
                    {
                        id: 4,
                        label: this.getLanguage['MEM']['LID']
                    },
                    {
                        id: 5,
                        label: this.getLanguage['MEM']['WAID']
                    },
                    {
                        id: 6,
                        label: this.getLanguage['MEM']['TGID']
                    },
                    {
                        id: 7,
                        label: this.getLanguage['MEM']['ZLID']
                    }
                ];
                //this.dd_weekday = constWeekday;

                //this.dd_monthday = [];

                //for (var i = 1; i <= 28; i++) {
                //    this.dd_monthday.push({
                //        id: i,
                //        label: i
                //    });
                //}

                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency2 = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.generateTempAgentGroupList);
                            }
                        }
                    });

            },
            getMissionList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }
                    path += (
                        "f.MN=" + (this.arr_FV["MN"] == null ? "" : this.arr_FV["MN"]) +
                        "&f.MT=" + (this.arr_FV["MT"] == null ? "" : this.arr_FV["MT"]) +
                        "&f.PT=" + (this.arr_FV["PT"] == null ? "" : this.arr_FV["PT"]) +
                        "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]));

                    if (this.arr_FV.CTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.CTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                }

                this.getDataApi(`/api/mission/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            if (d.D.Items == null) {
                                that.arr_Mission = [];
                            }
                            else {
                                that.arr_Mission = d.D.Items;
                            }
                            that.resizeTableHead();
                        }
                    });

            },
            getMissionPrizeList(missionId) {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page_1, this.int_RC_1, this.str_tableSortBy_1, this.bool_isSort_1);
                path += "&f.RS=2&f.IRP=1&f.MI=" + missionId;
                this.getDataApi(`/api/mission/pl?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP_1 = Math.max(d.D.TotalPages, 1);
                            that.int_Total_1 = d.D.TotalItems;
                            if (d.D.Items == null) {
                                that.obj_mission.MPrize = [];
                            }
                            else {
                                that.obj_mission.MPrize = d.D.Items;
                                if (that.bool_isCopyPrize) {
                                    that.totalAmount = 0;
                                }
                                else {
                                    var total = 0;
                                    for (var i = 0; i < d.D.Items.length; i++) {
                                        total += d.D.Items[i].A;
                                    }
                                    that.totalAmount = total;
                                }
                            }
                        }
                    });
               // check total prize amount
                    //var path = this.getListingParamQuery(1, 5000, 'I', true);
                    //path += "&f.RS=2&f.IRP=1&f.MI=" + missionId;

                    //this.getDataApi(`/api/mission/pl?${path}`,
                    //    function (d, s) {
                    //        that.bool_fullLoading = false;
                    //        if (s) {
                    //            if (d.D.Items == null) {
                    //                that.totalAmount = 0;
                    //            }
                    //            else {
                    //                var total = 0;
                    //                for (var i = 0; i < d.D.Items.length; i++) {
                    //                    total += d.D.Items[i].A;
                    //                }
                    //                that.totalAmount = total;
                    //            }
                    //        }
                    //    });
            },
            
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    //var that = this;
                    //var agi = 0;

                    //if (value != "") {
                    //    agi = value.split("-")[1];
                    //}
                    this.arr_FV["AGI"] = value;
                }
                else {
                    this.arr_FV["AGI"] = null;
                }
            },

            ValidationPrizeErrMsg(value, langKey = "") {
                if (langKey == '')
                    langKey = value;
                if (this.bool_PrizeListCV) {
                    var validateObj = this.$v.obj_prizelist[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        if (value == 'AGI')
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["GL"]["AGT"]);
                        else if (value == 'MEMI')
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MEM"]["U"]);
                        else
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MSA"][langKey]);
                    } else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage["MSA"][langKey]);
                    }
                }
            },
            ValidationMissionErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_MissionCV) {
                    if (langKey1 == "") {
                        langKey1 = "MSA";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }

                    var validateObj = this.$v.obj_mission[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        if (value == 'AOIQR') {
                            return this.getLanguage['MSA']['AOIQR'];
                        } else {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        if (value == 'CLD' || value == 'TP')
                            return String.format(this.utilGetErrorLanguage('MBGT'), this.getLanguage[langKey1][langKey2], 1);
                        else
                            return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minLengthValue != undefined && !validateObj.minLengthValue) {
                        return String.format(this.getLanguage['MSA']['ECWL'], 2);
                    }
                }
            },
            addMission() {
                this.bool_MissionCV = false;
                this.bool_fullLoading = true;
                this.totalAmount = 0;
                this.obj_mission.MPrize = [];
                this.setThousandCurrency(false);
                this.obj_mission = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "MN": "",
                    "IAGI": "",
                    "MT": null,
                    "MDV": "",
                    "MD": { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    "MSD": null,
                    "MED": null,
                    "TGI": "",
                    "GameIds": [],
                    "TGame": [],
                    "CI": null,
                    "MPrize": [],
                    "MDC": null,
                    "MPT": 1,
                    "MDA": null,
                    "MCOD": null,
                    "MTA": null,
                    "MBC": null,
                    "CLD": null,
                    "TBA": null,
                    "MINP": null,
                    "MAXP": null,
                    "TP": null,
                    "CDL": "",
                    "CD": null,
                    "enableEdit": true,
                    "AOIQR": null
                },
                this.missionEndDate = this.getTodayDate();
                this.obj_Post.SelectedBrands = [];
                this.AgentGroupChange();
                this.bool_OnOff = false;
                this.bool_DROOOnOff = false;
                this.bool_TROOOnOff = false;
                this.bool_LROOOnOff = false;
                this.bool_CDOnOff = false;
                this.bool_isAMV = true;
                this.bool_fullLoading = false;

            },
            editMission(id, bool_copy = false) {
                var that = this;
                this.bool_isCopyPrize = bool_copy;
                this.totalAmount = 0;
                this.obj_mission.MPrize = [];
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_MissionCV = false;
                this.visible = false;

                this.getDataApi(`/api/mission/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {

                            that.obj_mission = Object.assign(that.obj_mission, d.D);

                            var IAGI_temp = [];
                            if (that.obj_mission.IAGI != null && that.obj_mission.IAGI.length > 0) {
                                var temp = that.obj_mission.IAGI.split(",");
                                for (var i = 0; i < temp.length; i++) {
                                    IAGI_temp.push(temp[i]);
                                }
                            }

                            that.obj_mission.AGIT = IAGI_temp;

                            that.obj_mission.MD = {
                                startDate: that.getTodayDate(),
                                endDate: that.getTodayDate()
                            };

                            if (that.obj_mission.MSD != null) {
                                that.obj_mission.MD.startDate = that.obj_mission.MSD;
                            }

                            if (that.obj_mission.MED != null) {
                                that.obj_mission.MD.endDate = that.obj_mission.MED;
                                that.missionEndDate = that.obj_mission.MED;
                            }

                            if (that.obj_mission.OO == 1) {
                                that.bool_OnOff = true;
                            } else {
                                that.bool_OnOff = false;
                            }
                            if (that.obj_mission.DROO == 1) {
                                that.bool_DROOOnOff = true;
                            } else {
                                that.bool_DROOOnOff = false;
                            }
                            if (that.obj_mission.TROO == 1) {
                                that.bool_TROOOnOff = true;
                            } else {
                                that.bool_TROOOnOff = false;
                            }
                            if (that.obj_mission.LROO == 1) {
                                that.bool_LROOOnOff = true;
                            } else {
                                that.bool_LROOOnOff = false;
                            }
                            if (that.obj_mission.CDOO == 1) {
                                that.bool_CDOnOff = true;
                            } else {
                                that.bool_CDOnOff = false;
                            }
                            if (that.obj_mission.PT == 0) {
                                that.obj_mission.PT = null;
                            }
                            if (that.obj_mission.CLD == 0) {
                                that.obj_mission.CLD = null;
                            }
                            that.AgentGroupChange();
                            //that.CurrencyChange(that.obj_mission.CI);
                            that.int_Page_1 = 1;
                            that.int_IC_1 = 1;
                            that.getMissionPrizeList(that.obj_mission.I);

                            if (bool_copy == true) {
                                that.obj_mission.I = 0;
                                that.obj_mission.RS = 1;
                                that.obj_mission.enableEdit = true;
                                that.obj_mission.MD = {
                                    startDate: that.getTodayDate()
                                };
                                that.MissionStartDateChange(that.obj_mission.MD.startDate, that.obj_mission.MDT, that.obj_mission.MDV);
                            }

                            that.bool_isAMV = true;
                        }
                    });
            },
            saveMission() {

                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                var that = this;

                if (this.obj_mission.AGIT != null && this.obj_mission.AGIT.length > 0) {
                    this.obj_mission.IAGI = this.obj_mission.AGIT.join(',');
                } else {
                    this.obj_mission.IAGI = "";
                }

                if (this.obj_mission.CD != null && this.obj_mission.CD.length > 0) {
                    this.obj_mission.CDL = this.obj_mission.CD.join(',');
                } else {
                    this.obj_mission.CDL = "";
                }

                if (this.obj_mission.MD != null) {
                    if (this.obj_mission.MD.startDate != null) {
                        this.obj_mission.MSD = this.parseDateToJsonString(this.obj_mission.MD.startDate);
                        this.obj_mission.MED = this.parseDateToJsonString(this.missionEndDate);
                    }
                }
                this.bool_MissionCV = true;
                this.$v.obj_mission.$touch();

                if (!this.$v.obj_mission.$error) {
                    var that = this;
                    if (this.bool_OnOff == true) {
                        this.obj_mission.OO = 1;
                    } else {
                        this.obj_mission.OO = 0;
                    }
                    if (this.bool_DROOOnOff == true) {
                        this.obj_mission.DROO = 1;
                    } else {
                        this.obj_mission.DROO = 0;
                    }
                    if (this.bool_TROOOnOff == true) {
                        this.obj_mission.TROO = 1;
                    } else {
                        this.obj_mission.TROO = 0;
                    }
                    if (this.bool_LROOOnOff == true) {
                        this.obj_mission.LROO = 1;
                    } else {
                        this.obj_mission.LROO = 0;
                    }
                    if (this.bool_CDOnOff == true) {
                        this.obj_mission.CDOO = 1;
                    } else {
                        this.obj_mission.CDOO = 0;
                    }
                    if (this.bool_LROOOnOff == true && this.obj_mission.CLD == 0) {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1033'), (this.getLanguage['DLSS']['CLD']), "1"), 1000)
                        return false;
                    }
                    if (this.obj_mission.MINP && this.obj_mission.MINP > 0 && this.obj_mission.MAXP && this.obj_mission.MAXP > 0 && this.obj_mission.MAXP < this.obj_mission.MINP) {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, this.getLanguage['MSA']['MINMAX'] , 1000)
                        return false;
                    }
                    if (this.obj_mission.MAXP && this.obj_mission.MAXP > 0 && this.obj_mission.MAXP > this.obj_mission.TBA) {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, this.getLanguage['MSA']['GTBA'], 1000)
                        return false;
                    }

                    //if (this.obj_mission.PT == 1) {
                    //    this.obj_mission.MAXP = this.obj_mission.MINP;
                    //    var prizeAmount = (this.obj_mission.MINP && parseInt(this.obj_mission.MINP) > 0) ? parseInt(this.obj_mission.MINP) : (parseInt(this.obj_mission.TBA) / parseInt(this.obj_mission.TP));
                    //    for (var i = 0; i < this.obj_mission.MPrize.length; i++) {
                    //        this.obj_mission.MPrize[i].A = prizeAmount;
                    //    }
                    //} else if (this.obj_mission.PT == 2) {
                    //    for (var i = 0; i < this.obj_mission.MPrize.length; i++) {
                    //        if (this.obj_mission.MPrize[i].A == null || this.obj_mission.MPrize[i].A == 0) {
                    //            this.bool_fullLoading = false;
                    //            this.showErrorMessage(null, this.getLanguage['MSA']['RPG0'], 1000)
                    //            return false;
                    //        } else if ((this.obj_mission.MINP && this.obj_mission.MINP > this.obj_mission.MPrize[i].A) || (this.obj_mission.MAXP && this.obj_mission.MAXP < this.obj_mission.MPrize[i].A)) {
                    //            this.bool_fullLoading = false;
                    //            this.showErrorMessage(null, this.getLanguage['MSA']['RPMMR'], 1000)
                    //            return false;
                    //        }
                    //    }
                    //}
                    //this.totalAmount = 0;
                    //for (var i = 0; i < this.obj_mission.MPrize.length; i++) {
                    //    this.totalAmount += this.obj_mission.MPrize[i].A;
                    //}
                   
                    var remainTotalAmount = this.obj_mission.TBA - this.totalAmount;
                    var remainPrizeQty = this.obj_mission.TP - this.obj_mission.MPrize.length;
                    var AVGPrizeAmount = remainTotalAmount / remainPrizeQty;
                    if (remainPrizeQty < 0) {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, this.getLanguage['MSA']['RMQTY'], 1000)
                        return false;
                    }
                    else if (remainTotalAmount < 0 || (this.obj_mission.MINP && this.obj_mission.MINP > 0 && parseFloat(this.obj_mission.MINP) > parseFloat(AVGPrizeAmount))) {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(null, this.getLanguage['MSA']['ISTB'], 1000)
                        return false;
                    }
                    this.postDataApi(`/api/mission/s`, this.obj_mission, function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.bool_isAMV = false;
                            that.getMissionList();
                        }
                    });
                } else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["obj_mission"];
                    if (!validation) {
                        return;
                    }
                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeMission(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/mission/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getMissionList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            renderMissionCurrentStatus(statusCode) {
                return this.getLanguage['MSA']['SC' + statusCode];
            },
            renderMissionType(type) {
                return this.dd_MissionTypeOption[type - 1].label;
                //for (var i = 0; i < constMissionType.length; i++) {
                //    if (constMissionType[i].id == type)
                //        return constMissionType[i].label;
                //}
                //return "-";
            },
            renderPrizeType(type) {
                return this.dd_PrizeTypeOption[type - 1].label;
                //for (var i = 0; i < constMissionType.length; i++) {
                //    if (constMissionType[i].id == type)
                //        return constMissionType[i].label;
                //}
                //return "-";
            },
            renderMissionStyle(currentStatus) {
                if (currentStatus == 0) {
                    return { 'font-size': 'x-small', color: '#191919' };
                }
                if (currentStatus == 1) {
                    return { 'font-size': 'x-small', color: '#e8a317' };
                }
                else if (currentStatus == 2) {
                    return { 'font-size': 'x-small', color: '#0372ff' };
                }
                else if (currentStatus == 3) {
                    return { 'font-weight': 'bold', 'font-size': 'x-small', color: '#191919' };
                }

            },
            updateStatus(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        this.postDataApi(`/api/mission/us`, d,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.bool_isAMV = false;
                                    that.getMissionList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        this.getMissionList();
                    }
                });

            },
            clearDateRangeFilter() {
                this.arr_FV.CTS = {
                    startDate: "",
                    endDate: ""
                };
            },

            MissionDateRangePickerUpdateEvent(dt) {
                if (dt) {
                    if (dt.startDate) {
                        dt.startDate.setHours(0, 0, 0, 0);
                    }

                    if (dt.endDate) {
                        dt.endDate.setHours(23, 59, 59, 59, 997);
                    }
                }
                this.obj_mission.MD.startDate = dt.startDate;
                this.obj_mission.MD.endDate = dt.endDate;
                this.MissionStartDateChange(this.obj_mission.MD.startDate, this.obj_mission.MDT, this.obj_mission.MDV)
            },

            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            CurrencyChange(value) {
                //this.bool_providerloaded = false;
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            that.currencySymbol = val.label2;
                        }
                    });
                }
            },

            AgentGroupChange() {
                var agiList = [];
                if (this.obj_mission.AGIT && this.obj_mission.AGIT.length > 0) {
                    for (var i = 0; i < this.obj_mission.AGIT.length; i++) {
                        if (this.obj_mission.AGIT[i] != "" && this.obj_mission.AGIT[i].split("-")[0] == 3) {
                            agiList.push(this.obj_mission.AGIT[i].split("-")[1]);
                        }
                    }
                }
                var that = this;
                this.dd_currency = [];
                this.obj_Post.SelectedBrands = agiList;

                this.postDataApi(`/api/dd/curbyagilist`, this.obj_Post,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                            if (that.obj_mission.CI > 0) {
                                that.dd_currency.find(function (val, idx) {
                                    if (val.id == that.obj_mission.CI) {
                                        that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                                        that.currencySymbol = val.label2;
                                    }
                                });
                            }
                        }
                    });
                this.ddAgentList = this.deepClone(this.dd_agentgroup);
                if (this.ddAgentList.length > 0) {
                    this.ddAgentList.forEach(this.disableAgentGroupParent);
                }
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                    var agi = 0;
                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.searchAgi = agi;
                    this.obj_prizelist.AGIT = value;
                }
                else {
                    this.setSearchCriteriaAGI(null);
                    this.searchAgi = null;
                    this.searchAgent = null;
                    this.obj_prizelist.AGIT = null;
                }
                this.obj_prizelist.MEMI = null;
                this.obj_prizelist.U = null;
                this.obj_prizelist.AGI = this.searchAgi;
                this.ddDefaultMemberList = null;
                this.bool_cacheOptionValue = false;
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3" || (this.obj_mission.AGIT != null && this.obj_mission.AGIT.length > 0 && !this.obj_mission.AGIT.includes(item.id))) {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            generateTempAgentGroupList(item, index) {
                var agi = item.id.split("-");
                if (agi[0] == "3") {
                    this.dd_agentgroup_temp.push(item);
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.generateTempAgentGroupList);
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            PrizeAmountChange(field = 0, value = 0) {
                if (field == 1)
                    this.obj_mission.TBA = parseFloat(this.RemoveThousandSeparator(value, this.getThousandCurrency ? 3 : 2));
                else if (field == 2)
                    this.obj_mission.TP = this.RemoveThousandSeparator(value, 0);
                else if (field == 3) {
                    this.obj_mission.MINP = parseFloat(this.RemoveThousandSeparator(value, this.getThousandCurrency ? 3 : 2));
                    if (this.obj_mission.PT == 1)
                        this.obj_mission.MAXP = this.obj_mission.MINP;
                    return;
                }
                if (this.obj_mission.PT == 1 && this.obj_mission.TBA > 0 && this.obj_mission.TP > 0) {
                    this.obj_mission.MINP = this.obj_mission.TBA / this.obj_mission.TP;
                    this.obj_mission.MAXP = this.obj_mission.MINP;
                } else if (this.obj_mission.PT == 2 && field == 0) {
                    this.obj_mission.MINP = 0;
                    this.obj_mission.MAXP = 0;
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.MSA';
            this.$parent.showSubSubMenu = '';
            this.moduleIndex = this.checkModuleIndex('MSA', 'P', constAccessType.view, '', -1);
            if (this.moduleIndex == '6.10.1') {
                this.$parent.showSubSubMenu = 'MSA3';
            }
            this.getDropdownList();
            this.getMissionList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.HouseBrand = constHouseBrand;
            this.setThousandCurrency(false);
        }
    }
</script>

<style scoped>
    .pcDaterange .reportrange-text {
        display: block;
        padding: 0 !important;
        margin-top: -1px;
    }
    .tmntLanguage {
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .tmntLanguageLabel {
        min-width: max-content;
        padding: 0.5rem 0.5rem;
        font-size: smaller;
        border-width: 0px;
    }
    /* width */
    .tmntLanguage::-webkit-scrollbar {
        height: 5px;
    }
    /* Track */
    .tmntLanguage::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    /* Handle */
    .tmntLanguage::-webkit-scrollbar-thumb {
        background: #888; 
    }
    /* Handle on hover */
    .tmntLanguage::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }
    .flagClass {
        height: 20px;
        width: 20px;
    }
    .form-control[readonly] {
        background: #f9f9f9 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/Mission.vue